import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import { IMAGES, SIDEBAR_ITEMS, scrollToTop } from "src/shared/utils/appConstant";
// import images
import wmp_logo from "src/shared/assets/images/wmp-logo.svg";
import menu_icon from "src/shared/assets/images/menu-icon.svg";
import cross from "src/shared/assets/images/cross.svg";
import dropdown_arrow from "src/shared/assets/images/dropdown-arrow.svg";
import { Link, useLocation } from "react-router-dom";
import useModal from "src/shared/hooks/useModal";
import Modal from "../contact/components/modal";
import { SOCIAL_LOGIN_ENDPOINT } from "src/shared/utils/string";
import { pageRoutes } from "src/shared/utils/pageRoutes.constant";

function Sidebar() {
  const location = useLocation();
  const isMarketplaceActive = location.pathname === pageRoutes.Marketplace;
  const [sidebarOpen, setSidebarOpen] = useState<Boolean>(false); // To store the state of Sidebar in Mobile View whether it is open or not
  const [dropdownSelected, setDropdownSelected] = useState<String>(""); // To store the state of Dropdown state in Mobile View whether it is open or not under Sidebar options

  const componentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Check if the click is outside the sidebar wrapper and sidebar is open
      if (sidebarOpen && componentRef.current && !componentRef.current.contains(event.target as Node)) {
        setSidebarOpen(false);
      }
    };

    // Only add event listener when sidebar is open
    if (sidebarOpen) {
      document.addEventListener('click', handleClickOutside);
    }

    // Clean up the event listener
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [sidebarOpen]);

  useEffect(() => {
    const mobileSidebar = document.getElementById("mobileSidebarContent");
    const items = document.getElementsByClassName("items") as HTMLSelectElement;
    const selectedArray = Array.from(items);

    //  Sidebar display toggle to show and hide the Sidebar
    if (sidebarOpen) {
      mobileSidebar?.classList.add("sidebar_items");
      mobileSidebar?.classList.remove("display-none");
      selectedArray.forEach((element) => {
        element.classList.add("sidebarContent");
        element.classList.remove("display-none");
      });
    } else {
      setDropdownSelected(prev => (prev !== "" ? "" : prev));
      mobileSidebar?.classList.remove("sidebar_items");
      mobileSidebar?.classList.add("display-none");
      selectedArray.forEach(element => {
        element.classList.remove("sidebarContent");
        element.classList.add("display-none");
      });
      // Remove block property from all dropdown options
      const options = document.getElementsByClassName(
        "dropdown-options"
      ) as HTMLSelectElement;
      const selectedOptionArray = Array.from(options);
      const arrowOptions = document.getElementsByClassName(
        "dropdown-arrow"
      ) as HTMLSelectElement;
      const selectedArrowOptionArray = Array.from(arrowOptions);
      selectedOptionArray.forEach((element, index) => {
        element.classList.remove("display-toggle");
        selectedArrowOptionArray[index].classList.remove("rotated");
      });
    }
  }, [sidebarOpen]);



  // For Mobile View, Toggle DropDown Items
  const handleDropdownToggle = (id: string, optionId: string) => {
    const options = document.getElementsByClassName(
      "dropdown-options"
    ) as HTMLSelectElement;
    const selectedOptionArray = Array.from(options);

    const arrowOptions = document.getElementsByClassName(
      "dropdown-arrow"
    ) as HTMLSelectElement;
    const selectedArrowOptionArray = Array.from(arrowOptions);

    setDropdownSelected(prev => (prev !== id ? id : prev));

    // Remove block property to the sidebar options if un-selected and remove rotated property from the icon

    if (dropdownSelected === id) {
      selectedOptionArray.forEach((element, index) => {
        element.classList.remove("display-toggle");
        selectedArrowOptionArray[index].classList.remove("rotated");
      
      });
      setDropdownSelected(prev => (prev !== "" ? "" : prev));
    } else {
      // Add block property to the sidebar options if selected and add rotated property from the icon
      selectedOptionArray.forEach((element, index) => {
        if (element.id === optionId) {
          element.classList.add("display-toggle");
          selectedArrowOptionArray[index].classList.add("rotated");
         
        } else {
          element.classList.remove("display-toggle");
          selectedArrowOptionArray[index].classList.remove("rotated");
        }
      });
    }
  };

  const closeSideBar = () => {
    setSidebarOpen(false);
    scrollToTop();
  }
  const closeSideBarHomeIcon = () => {
    setSidebarOpen(false);
    scrollToTop();
    setButtonVisible(true);
  }
  // contact modal
  const { isOpen, toggle } = useModal();
  // Contact Button visibility
  const [buttonVisible, setButtonVisible] = useState(true);
  return (
    <div ref={componentRef}>
      <div className="sidebar">
        {/* Logo Section */}
        <div className="navbar-logo">
          <div className="menu-icon-div">
            <img
              src={!sidebarOpen ? menu_icon : cross}
              alt="hamburger_icon"
              className="display-toggle pd-left-10 pd-right-10"
              onClick={() => setSidebarOpen((prev: Boolean) => !prev)}
            ></img>
          </div>
          <Link to={pageRoutes.Home} onClick={closeSideBarHomeIcon} className="img-size">
            <img src={wmp_logo} alt="wmp logo" className="img-size"></img>
          </Link>
          <div className="navbar-contact mobile-contact">
            <Link to={pageRoutes.Contact} className="link-text-decoration" onClick={closeSideBar}>
              <button className="contact-btn" onClick={() => setButtonVisible(false)}>
                {SIDEBAR_ITEMS.CONTACT_US}
              </button>
            </Link>
          </div>
        </div>

        {/* Navigation Section */}
        <div className="navbar-nav" id="sidebarContent">
          <div className="display-none items nav-pd">
            <div
              // className="pd-5"
              id="sidebarItem1"
              onClick={() =>
                handleDropdownToggle("sidebarItem1", "sidebarOptions1")
              }
            >
              <div className="option-li">
                <p className="sidebar_item sidebar_item_mobview">{SIDEBAR_ITEMS.WHO_WE_ARE}</p>
                <img
                  src={dropdown_arrow}
                  alt="arrow"
                  className="dropdown-arrow display-toggle"
                ></img>
              </div>
              <div id="sidebarOptions1" className="dropdown-options">
                <div className="arrow-left display-none"></div>
                <div className="options mg-top-40">
                  <div className="options-inner">
                   <Link to= {pageRoutes.AboutUs} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                      <p className="margin-bottom">{SIDEBAR_ITEMS.ABOUT_US}</p>
                    </Link>
                    <span className="option-separator">|</span>
                    <Link to={pageRoutes.Leadership} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                      <p className="margin-bottom">{SIDEBAR_ITEMS.LEADERSHIP}</p>
                    </Link>
                    <span className="option-separator">|</span>
                    <Link to= {pageRoutes.Team} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                      <p className="margin-bottom">{SIDEBAR_ITEMS.TEAM}</p>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <hr className="li-separator"></hr>

            <div
              // className="pd-5"
              id="sidebarItem2"
              onClick={() =>
                handleDropdownToggle("sidebarItem2", "sidebarOptions2")
              }
            >
              <div className="option-li">
                <p className="sidebar_item sidebar_item_mobview">{SIDEBAR_ITEMS.SERVICES}</p>
                <img
                  src={dropdown_arrow}
                  alt="arrow"
                  className="dropdown-arrow display-toggle"
                ></img>
              </div>

              <div id="sidebarOptions2" className="dropdown-options">
                <div className="arrow-left display-none"></div>
                <div className="options-services services-grid mg-top-120">
                  <div className="service-column">
                    <div className="service-main">
                      <Link to={pageRoutes.AIML} onClick={closeSideBarHomeIcon} className="sidebar_item_option main-service">
                        <p>{SIDEBAR_ITEMS.AIML}</p>
                      </Link>
                    </div>
                    <div className="service-subs">
                      <Link to={pageRoutes.AIPoweredAutomation} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>AI-Powered Automation</p>
                      </Link>
                      <Link to={pageRoutes.PredictiveAnalytics} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Predictive Analytics & Forecasting</p>
                      </Link>
                      <Link to={pageRoutes.NLP} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Natural Language Processing (NLP)</p>
                      </Link>
                      <Link to={pageRoutes.MachineLearning} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Machine Learning & Deep Learning</p>
                      </Link>
                      <Link to={pageRoutes.AiOnCloud} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>AI on the Cloud</p>
                      </Link>
                    </div>
                  </div>
                  
                  <div className="service-column">
                    <div className="service-main">
                      <Link to={pageRoutes.IOTAutomation} onClick={closeSideBarHomeIcon} className="sidebar_item_option main-service">
                        <p>{SIDEBAR_ITEMS.IOT_AUTOMATION}</p>
                      </Link>
                    </div>
                    <div className="service-subs">
                      <Link to={pageRoutes.RadiusDeviceUnlocking} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Radius-Based Device Unlocking</p>
                      </Link>
                      <Link to={pageRoutes.SmartSecurityMonitoring} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Smart Security Monitoring System</p>
                      </Link>
                      <Link to={pageRoutes.NetworkManagementSystem} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Network Management System (NMS)</p>
                      </Link>
                      <Link to={pageRoutes.SecuritySurveillance} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Security & Surveillance</p>
                      </Link>
                    </div>
                  </div>
                  
                  <div className="service-column">
                    <div className="service-main">
                      <Link to={pageRoutes.DevOps} onClick={closeSideBarHomeIcon} className="sidebar_item_option main-service">
                        <p>{SIDEBAR_ITEMS.CLOUD_DEVOPS}</p>
                      </Link>
                    </div>
                    <div className="service-subs">
                      <Link to={pageRoutes.CloudInfra} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Cloud Infrastructure Consulting</p>
                      </Link>
                      <Link to={pageRoutes.CloudMigration} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Cloud Migration</p>
                      </Link>
                      <Link to={pageRoutes.DevOpsAuto} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>DevOps Automation</p>
                      </Link>
                      <Link to={pageRoutes.DevopsOperations} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>DevOps Operations</p>
                      </Link>
                      <Link to={pageRoutes.Security} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Security & Cost Optimization</p>
                      </Link>
                    </div>
                  </div>
                  
                  <div className="service-column">
                    <div className="service-main">
                      <Link to={pageRoutes.SoftwareEngineering} onClick={closeSideBarHomeIcon} className="sidebar_item_option main-service">
                        <p>{SIDEBAR_ITEMS.SOFTWARE_ENGINEERING}</p>
                      </Link>
                    </div>
                    <div className="service-subs">
                      <Link to={pageRoutes.WebAppDev} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Web App Development</p>
                      </Link>
                      <Link to={pageRoutes.MobileAppDev} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Mobile App Development</p>
                      </Link>
                      <Link to={pageRoutes.ProductReEngg} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Project Reengineering</p>
                      </Link>
                      <Link to={pageRoutes.SoftwareIntegration} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Software Integration</p>
                      </Link>
                      <Link to={pageRoutes.POC} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Proof Of Concepts</p>
                      </Link>
                    </div>
                  </div>
                  
                  <div className="service-column">
                    <div className="service-main">
                      <Link to={pageRoutes.QA} onClick={closeSideBarHomeIcon} className="sidebar_item_option main-service">
                        <p>{SIDEBAR_ITEMS.QUALITY_ASSURANCE}</p>
                      </Link>
                    </div>
                    <div className="service-subs">
                      <Link to={pageRoutes.TestingAndAutomation} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Testing & Automation</p>
                      </Link>
                      <Link to={pageRoutes.ApiDrivenTesting} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>API Driven Testing</p>
                      </Link>
                      <Link to={pageRoutes.PerformanceTesting} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Performance Testing</p>
                      </Link>
                      <Link to={pageRoutes.PenetrationTesting} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Penetration Testing</p>
                      </Link>
                    </div>
                  </div>
                  
                  <div className="service-column">
                    <div className="service-main">
                      <Link to={pageRoutes.Designing} onClick={closeSideBarHomeIcon} className="sidebar_item_option main-service">
                        <p>{SIDEBAR_ITEMS.DESIGNING}</p>
                      </Link>
                    </div>
                    <div className="service-subs">
                      <Link to={pageRoutes.WebDesigning} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Web Designing</p>
                      </Link>
                      <Link to={pageRoutes.AppDesigning} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>App Designing</p>
                      </Link>
                      <Link to={pageRoutes.InfoArchitectureDesign} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Information Architecture Design</p>
                      </Link>
                    </div>
                  </div>
                  
                  <div className="service-column">
                    <div className="service-main">
                      <Link to={pageRoutes.Operations} onClick={closeSideBarHomeIcon} className="sidebar_item_option main-service">
                        <p>{SIDEBAR_ITEMS.OPERATIONS}</p>
                      </Link>
                    </div>
                    <div className="service-subs">
                      <Link to={pageRoutes.TechManagement} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Technical Writing</p>
                      </Link>
                      <Link to={pageRoutes.ProjectManagement} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Project Management</p>
                      </Link>
                      <Link to={pageRoutes.ProductManagement} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Product Strategy & Management</p>
                      </Link>
                      <Link to={pageRoutes.Support} onClick={closeSideBarHomeIcon} className="sidebar_item_sub">
                        <p>Level 3 Support (L3: 24 X 7)</p>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr className="li-separator"></hr>

            <div
              // className="pd-5"
              id="sidebarItem3"
              onClick={() =>
                handleDropdownToggle("sidebarItem3", "sidebarOptions3")
              }
            >
              <div className="option-li">
                <p className="sidebar_item sidebar_item_mobview">{SIDEBAR_ITEMS.COMPANY}</p>
                <img
                  src={dropdown_arrow}
                  alt="arrow"
                  className="dropdown-arrow display-toggle"
                ></img>
              </div>
              <div id="sidebarOptions3" className="dropdown-options">
                <div className="arrow-left display-none"></div>
                <div className="options mg-top-40">
                  <div className="options-inner">
                    <Link to={pageRoutes.Blog} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                      <p className="margin-bottom">{SIDEBAR_ITEMS.BLOGS}</p>
                    </Link>
                    <span className="option-separator">|</span>
                    <Link to={pageRoutes.SuccessStories} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                     <p className="margin-bottom">{SIDEBAR_ITEMS.SUCCESS_STORIES}</p> 
                    </Link>
                    <span className="option-separator">|</span>
                    <Link to={pageRoutes.LifeAtWmp} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                      <p className="margin-bottom">{SIDEBAR_ITEMS.LIFE_AT_WMP}</p>
                    </Link>
                    <span className="option-separator">|</span>
                    <Link to={pageRoutes.Awards} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                     <p className="margin-bottom">{SIDEBAR_ITEMS.AWARDS}</p> 
                    </Link>
                  </div>
                </div>
              </div>
            </div>


            <hr className="li-separator"></hr>

            <div id="sidebarItem4">
              <div className="option-li">
                <Link
                  to={pageRoutes.Marketplace}
                  onClick={closeSideBarHomeIcon}
                  className="link-text-decoration"
                >
                  <p className={`sidebar_item sidebar_item_mobview ${isMarketplaceActive ? "active-marketplace-link" : ""}`}>
                    {SIDEBAR_ITEMS.MARKETPLACE}
                  </p>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="navbar-contact web-contact">
            <a href="https://careers.wingmp.com/jobs" target="_blank" rel="noopener noreferrer" className="link-text-decoration">
              <button className="careers-btn">
                {SIDEBAR_ITEMS.CAREERS}
              </button>
            </a>
            <button className="contact-btn" style={{ visibility: buttonVisible ? 'visible' : 'hidden' }} onClick={toggle}>
              {SIDEBAR_ITEMS.CONTACT_US}
            </button>
            <Modal isOpen={isOpen} toggle={toggle}></Modal>
          </div>

        {/* Mobile Sidebar Wrapper */}
        <div className="sidebar-wrapper" id="mobileSidebarContent">
          <div className="display-none items nav-pd">
            <div
              id="mobileSidebarItem1"
              onClick={() =>
                handleDropdownToggle("mobileSidebarItem1", "mobileSidebarOptions1")
              }
            >
              <div className="option-li">
                <p className="sidebar_item sidebar_item_mobview">{SIDEBAR_ITEMS.WHO_WE_ARE}</p>
                <img
                  src={dropdown_arrow}
                  alt="arrow"
                  className="dropdown-arrow display-toggle"
                ></img>
              </div>
              <div id="mobileSidebarOptions1" className="dropdown-options">
                <div className="arrow-left display-none"></div>
                <div className="options">
                 <Link to= {pageRoutes.AboutUs} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                    <p className="margin-bottom">{SIDEBAR_ITEMS.ABOUT_US}</p>
                  </Link>
                  {/* <hr className="options-separator display-none"></hr> */}
                  <Link to={pageRoutes.Leadership} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                    <p className="margin-bottom">{SIDEBAR_ITEMS.LEADERSHIP}</p>
                  </Link>
                  {/* <hr className="options-separator display-none"></hr> */}
                  <Link to= {pageRoutes.Team} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                    <p className="margin-bottom">{SIDEBAR_ITEMS.TEAM}</p>
                  </Link>
                </div>
              </div>
            </div>

            <hr className="li-separator"></hr>

            <div
              id="mobileSidebarItem2"
              onClick={() =>
                handleDropdownToggle("mobileSidebarItem2", "mobileSidebarOptions2")
              }
            >
              <div className="option-li">
                <p className="sidebar_item sidebar_item_mobview">{SIDEBAR_ITEMS.SERVICES}</p>
                <img
                  src={dropdown_arrow}
                  alt="arrow"
                  className="dropdown-arrow display-toggle"
                ></img>
              </div>

              <div id="mobileSidebarOptions2" className="dropdown-options">
                <div className="arrow-left display-none"></div>
                <div className="options">
                    <Link to={pageRoutes.AIML} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                      <p className="margin-bottom">{SIDEBAR_ITEMS.AIML}</p>
                    </Link>
                  
                    <Link to={pageRoutes.IOTAutomation} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                      <p className="margin-bottom">{SIDEBAR_ITEMS.IOT_AUTOMATION}</p>
                    </Link>
                  
                    <Link to={pageRoutes.DevOps} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                      <p className="margin-bottom">{SIDEBAR_ITEMS.CLOUD_DEVOPS}</p>
                    </Link>
                  
                    <Link to={pageRoutes.SoftwareEngineering} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                      <p className="margin-bottom">{SIDEBAR_ITEMS.SOFTWARE_ENGINEERING}</p>
                    </Link>
                  
                    <Link to={pageRoutes.QA} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                      <p className="margin-bottom">{SIDEBAR_ITEMS.QUALITY_ASSURANCE}</p>
                    </Link>
                  
                    <Link to={pageRoutes.Designing} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                      <p className="margin-bottom">{SIDEBAR_ITEMS.DESIGNING}</p>
                    </Link>
                  
                    <Link to={pageRoutes.Operations} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                      <p className="margin-bottom">{SIDEBAR_ITEMS.OPERATIONS}</p>
                    </Link>
                </div>
              </div>
            </div>
            <hr className="li-separator"></hr>

            <div
              id="mobileSidebarItem3"
              onClick={() =>
                handleDropdownToggle("mobileSidebarItem3", "mobileSidebarOptions3")
              }
            >
              <div className="option-li">
                <p className="sidebar_item sidebar_item_mobview">{SIDEBAR_ITEMS.COMPANY}</p>
                <img
                  src={dropdown_arrow}
                  alt="arrow"
                  className="dropdown-arrow display-toggle"
                ></img>
              </div>
              <div id="mobileSidebarOptions3" className="dropdown-options">
                <div className="arrow-left display-none"></div>
                <div className="options">
                  <Link to={pageRoutes.Blog} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                    <p className="margin-bottom">{SIDEBAR_ITEMS.BLOGS}</p>
                  </Link>
                  <Link to={pageRoutes.SuccessStories} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                   <p className="margin-bottom">{SIDEBAR_ITEMS.SUCCESS_STORIES}</p> 
                  </Link>
                  <Link to={pageRoutes.LifeAtWmp} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                    <p className="margin-bottom">{SIDEBAR_ITEMS.LIFE_AT_WMP}</p>
                  </Link>
                  <Link to={pageRoutes.Awards} onClick={closeSideBarHomeIcon} className="sidebar_item_option">
                   <p className="margin-bottom">{SIDEBAR_ITEMS.AWARDS}</p> 
                  </Link>
                </div>
              </div>
            </div>

            <hr className="li-separator"></hr>

            <div id="mobileSidebarItem4">
              <div className="option-li">
                <Link
                  to={pageRoutes.Marketplace}
                  onClick={closeSideBarHomeIcon}
                  className="link-text-decoration"
                >
                  <p className={`sidebar_item sidebar_item_mobview ${isMarketplaceActive ? "active-marketplace-link" : ""}`}>
                    {SIDEBAR_ITEMS.MARKETPLACE}
                  </p>
                </Link>
              </div>
            </div>
          
          </div>

          {/* Mobile Sidebar Careers Action */}
          <div className="mobile-sidebar-careers">
            <a href="https://careers.wingmp.com/jobs" target="_blank" rel="noopener noreferrer" className="link-text-decoration">
              <button className="careers-btn mobile-careers-btn">
                {SIDEBAR_ITEMS.CAREERS}
              </button>
            </a>
          </div>

          {/* Footer of SideBar */}
          <div className="sidebar_footer">
            <hr className="separator display-none"></hr>
            <a href={SOCIAL_LOGIN_ENDPOINT.LINKEDIN} target="_blank" rel="noreferrer" className="sidebar_footer_img">
              <img
                src={IMAGES.NAV_FOOTER_LINKDIN}
                alt="linkedin"
              ></img>
            </a>
            <a href={SOCIAL_LOGIN_ENDPOINT.INSTAGRAM} target="_blank" rel="noreferrer" className="sidebar_footer_img">
              <img
                src={IMAGES.NAV_FOOTER_INSTAGRAM}
                alt="instagram"
              ></img>
            </a>
            <a href={SOCIAL_LOGIN_ENDPOINT.FACEBOOK} target="_blank" rel="noreferrer" className="sidebar_footer_img">
              <img
                src={IMAGES.NAV_FOOTER_FACEBOOK}
                alt="facebook"
              ></img>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
